import script from "./ConfigDataSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigDataSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigDataSection.vue?vue&type=style&index=0&id=ffae6044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffae6044"]])

export default __exports__